import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
//primereact
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
//components
import Modal from "../modal/Modal";
//services
import { getStatusPayment } from "../../services/CreateAccount/getStatusPayment";
//context
// import { useCreateAccountContext } from "../../../context/CreateAccountContext";
//assets
import sucess from "../../assets/success/check.gif";
import expiry from "../../assets/errors/expiryError.gif";
import { toast } from "react-toastify";
import { getPixGenerate } from "../../services/CreateAccount/getPixGenerate";

const ModalPixPayment = ({
  visible,
  setVisible,
  pixDataQR,
  setPixDataQR,
  onContinue,
}) => {
  const navigate = useNavigate();
  const [timeLeft, setTimeLeft] = useState(0);
  const [showTooltip, setShowTooltip] = useState(false);
  const [paymentCompleted, setPaymentCompleted] = useState(false);

  const { data: paymentPix } = useQuery({
    queryKey: ["paymentPix"],
    queryFn: () => getStatusPayment(pixDataQR.id ? pixDataQR.id : ""),
    enabled: pixDataQR !== null,
    refetchInterval: 10000,
  });

  const copyCode = async () => {
    await navigator.clipboard.writeText(pixDataQR.copy);

    setShowTooltip(true);

    setTimeout(() => {
      setShowTooltip(false);
    }, 1000);
  };

  const handleClickPix = async () => {
    const notification = toast.loading("Gerando seu código PIX");
    try {
      const response = await getPixGenerate(
        pixDataQR.id ? pixDataQR.id : ""
      );
      // console.log(response);
      setPixDataQR({
        id: response.success.payment_id,
        copy: response.success.pix,
        qr_code: response.success.link_QRcode,
        timer: 7,
      });
      toast.update(notification, {
        render: "Código pix gerado",
        autoClose: 2000,
        type: "success",
        isLoading: false,
      });
    } catch (error) {
      toast.update(notification, {
        render: "Erro a gerar código PIX",
        autoClose: 3000,
        type: "error",
        isLoading: false,
      });
    }
  };

  useEffect(() => {
    if (paymentPix) {
      if (paymentPix.payment.status === 1) {
        // console.log(paymentPix);
        setPaymentCompleted(true);
      }
    }
  }, [paymentPix]);

  useEffect(() => {
    if (pixDataQR) {
      const totalTime = pixDataQR.timer * 60;
      setTimeLeft(totalTime);

      const interval = setInterval(() => {
        setTimeLeft((prevTime) => {
          if (prevTime <= 1) {
            clearInterval(interval);
            return 0;
          }
          return prevTime - 1;
        });
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [pixDataQR]);

  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;

  return (
    <Modal
      dynamicTitle={
        <div className="w-100 d-flex justify-content-center">
          <i
            className="fa-brands fa-pix"
            style={{ color: "#14b8a6", fontSize: "40px" }}
          ></i>
        </div>
      }
      visible={visible}
      dynamicWidth={window.innerWidth <= 992 ? "85vw" : "25vw"}
      onHide={() => setVisible(false)}
      closable={false}
    >
      {pixDataQR && (
        <>
          {paymentCompleted ? (
            <div className="text-center">
              <h2>Pagamento Efetuado</h2>
              <img
                src={sucess}
                alt="success"
                className="w-100"
                style={{ filter: "hue-rotate(54deg)" }}
              />
              <Button
                // icon="fa-regular fa-clone"
                label="Continuar"
                className="rounded-pill"
                onClick={() => onContinue()}
              />
            </div>
          ) : timeLeft === 0 ? (
            <>
              <div className="text-center">
                <h2>Link Expirado</h2>
                <img
                  src={expiry}
                  alt="error"
                  className="w-100"
                />
                <Button
                  // icon="fa-regular fa-clone"
                  label="Gerar Novo Código"
                  className="rounded-pill"
                  onClick={() => handleClickPix()}
                />
              </div>
            </>
          ) : (
            <div className="text-center">
              <h2>Pagamento via PIX</h2>
              <h4 className="text-muted">
                O QR Code expira em {minutes}:
                {seconds < 10 ? `0${seconds}` : seconds}
              </h4>
              <img src={pixDataQR.qr_code} alt="qrcode" />
              <div
                className="text-muted"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  position: "relative",
                  margin: "20px 0 40px 0",
                }}
              >
                <hr
                  style={{
                    width: "100%",
                    border: "none",
                    borderTop: "1px solid #ccc",
                    margin: "0",
                  }}
                />
                <span
                  style={{
                    position: "absolute",
                    backgroundColor: "white",
                    padding: "0 10px",
                    fontSize: "16px",
                    fontWeight: 600,
                  }}
                >
                  Ou copie o código
                </span>
              </div>

              <div className="row">
                <div className="col-md-10">
                  <InputText
                    readOnly
                    placeholder="Pesquisar"
                    className="p-inputtext-sm h-100 w-100 rounded-3"
                    value={pixDataQR?.copy}
                  />
                </div>
                <div className="col-md-2 position-relative">
                  <Button
                    icon="fa-regular fa-clone"
                    className="rounded-3"
                    onClick={copyCode}
                  />

                  {showTooltip && (
                    <div
                      style={{
                        position: "absolute",
                        top: "-40px",
                        left: "50%",
                        transform: "translateX(-50%)",
                        backgroundColor: "#14b8a6",
                        color: "white",
                        padding: "5px 10px",
                        borderRadius: "5px",
                        fontSize: "14px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Copiado!
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </Modal>
  );
};

export default ModalPixPayment;
